// extracted by mini-css-extract-plugin
export default {"root":"RjiuPXvcYL","content":"Qjb0sHYFSW"};